export default __webpack_public_path__ + "static/media/49.c8124625.jpg";